var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _g, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPauseButton(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 56,
    viewBox: "0 0 59 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_2347_51594)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.119 0.0638875L11.1777 0.865022C11.1777 0.865022 12.4529 -0.00577643 12.7337 2.88982e-05C13.0145 0.0116395 39.7175 0.185799 39.9339 0.191605C40.1445 0.19741 47.4915 0.418012 47.4915 0.418012C47.4915 0.418012 50.387 1.84032 50.814 2.20025C51.2352 2.56598 53.9961 7.55276 54.0605 8.40034C54.1307 9.24211 53.6393 24.4404 53.6393 24.4404L52.6507 26.4433L53.5457 26.809L52.4869 42.3034C52.4869 42.3034 49.9717 45.5718 49.6207 45.7054C49.2639 45.8331 16.7699 46.1117 16.7699 46.1117L15.3601 45.0842L14.0206 46.0247C14.0206 46.0247 11.0549 45.8621 10.6981 45.5022C10.3471 45.1422 7.31122 40.0045 7.31122 40.0045C7.31122 40.0045 6.60343 26.8729 6.74381 26.5942C6.8842 26.3214 7.09478 24.2895 7.09478 24.2895C7.09478 24.2895 6.81401 23.0181 6.59758 22.4492C6.38699 21.8803 6.10037 15.2158 6.03017 14.583C5.95998 13.9502 5.39258 6.50199 5.39258 6.50199C5.39258 6.50199 6.80231 2.40924 7.15913 2.06672C7.50425 1.73582 10.119 0.0638875 10.119 0.0638875Z",
    fill: "url(#paint0_linear_2347_51594)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.119 0.0638875L11.1777 0.865022C11.1777 0.865022 12.4529 -0.00577643 12.7337 2.88982e-05C13.0145 0.0116395 39.7175 0.185799 39.9339 0.191605C40.1445 0.19741 47.4915 0.418012 47.4915 0.418012C47.4915 0.418012 50.387 1.84032 50.814 2.20025C51.2352 2.56598 53.9961 7.55276 54.0605 8.40034C54.1307 9.24211 53.6393 24.4404 53.6393 24.4404L52.6507 26.4433L53.5457 26.809L52.4869 42.3034C52.4869 42.3034 49.9717 45.5718 49.6207 45.7054C49.2639 45.8331 16.7699 46.1117 16.7699 46.1117L15.3601 45.0842L14.0206 46.0247C14.0206 46.0247 11.0549 45.8621 10.6981 45.5022C10.3471 45.1422 7.31122 40.0045 7.31122 40.0045C7.31122 40.0045 6.60343 26.8729 6.74381 26.5942C6.8842 26.3214 7.09478 24.2895 7.09478 24.2895C7.09478 24.2895 6.81401 23.0181 6.59758 22.4492C6.38699 21.8803 6.10037 15.2158 6.03017 14.583C5.95998 13.9502 5.39258 6.50199 5.39258 6.50199C5.39258 6.50199 6.80231 2.40924 7.15913 2.06672C7.50425 1.73582 10.119 0.0638875 10.119 0.0638875Z",
    fill: "url(#paint1_linear_2347_51594)"
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.3
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M54.0661 9.07935C52.7265 11.4711 49.2344 17.7525 49.2344 18.095C49.2344 18.513 49.5152 25.1543 49.5152 25.1543C49.5152 25.1543 51.7965 21.6421 53.8204 18.4898C53.9315 14.9021 54.0485 10.7223 54.0661 9.07935Z",
    fill: "#A4EEFF"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M6.58594 22.4607L10.0254 23.4766L7.31128 25.3517L10.821 23.3199L6.58594 22.4607Z",
    fill: "#4AFFFF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.37,
    d: "M49.7318 45.6239L49.4159 45.3337L45.4032 42.3265C45.4032 42.3265 36.6347 42.013 33.8562 41.9201C31.0777 41.8272 21.2739 42.7445 21.0868 42.7445C20.8996 42.7445 15.9977 42.193 15.9977 42.193C15.9977 42.193 15.3308 41.3396 14.7868 41.2119C14.4242 41.1306 12.0961 43.6559 10.5752 45.3627C10.622 45.4323 10.6629 45.4788 10.6863 45.502C11.0432 45.8619 14.0089 46.0245 14.0089 46.0245L15.3484 45.084L16.7581 46.1116C16.7581 46.1116 49.2521 45.8329 49.6089 45.7052C49.6382 45.6936 49.6791 45.6646 49.7259 45.6181L49.7318 45.6239Z",
    fill: "url(#paint2_linear_2347_51594)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.37,
    d: "M37.6693 45.9081C42.115 45.8559 46.0868 45.8036 48.14 45.7572C48.7191 45.5366 49.4152 45.3276 49.4152 45.3276L45.4024 42.3204L33.8555 41.9141C34.0777 42.454 36.3883 44.689 37.6693 45.9023V45.9081Z",
    fill: "url(#paint3_linear_2347_51594)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M25.258 0.0869699C22.8831 0.069554 20.555 0.0579433 18.5603 0.0405273C17.8408 1.24223 16.6709 3.48309 16.6709 3.48309L22.4444 3.79657C22.4444 3.79657 24.1524 1.62538 25.258 0.0811646V0.0869699Z",
    fill: "url(#paint4_linear_2347_51594)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M50.8133 2.20587C50.4038 1.85755 47.7247 0.539745 47.5083 0.429443L44.332 3.73848C44.332 3.73848 47.4791 6.31604 47.9821 5.47427C48.2337 5.05048 49.5849 3.59915 50.8659 2.26393C50.8425 2.2407 50.825 2.21748 50.8074 2.20007L50.8133 2.20587Z",
    fill: "url(#paint5_linear_2347_51594)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M5.38672 6.50763C5.38672 6.50763 5.40427 6.70501 5.42767 7.03592L10.0956 8.06926L13.2543 3.73269L10.119 0.0637207L7.15327 2.07236L7.05968 2.20008C6.60342 2.97799 5.38672 6.50183 5.38672 6.50183V6.50763Z",
    fill: "url(#paint6_linear_2347_51594)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M53.5042 27.3601L53.2292 26.6866L49.2574 25.6765L49.0234 31.3309L52.8666 36.6312L53.5042 27.3601Z",
    fill: "url(#paint7_linear_2347_51594)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M13.0614 3.83154C13.2662 3.83154 14.945 3.85476 14.945 3.6748C14.945 3.49483 12.7339 2.88982e-05 12.7339 2.88982e-05C12.4531 -0.00577643 11.1779 0.865022 11.1779 0.865022L10.1191 0.0638875C10.1191 0.0638875 12.8567 3.83735 13.0614 3.83735V3.83154Z",
    fill: "url(#paint8_linear_2347_51594)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M12.6581 4.23804C12.6581 4.23804 9.94979 7.59932 10.0434 8.75458C10.137 9.90403 11.2074 23.2621 11.2074 24.1271C11.2074 24.9921 12.272 37.0962 12.272 37.0962C12.272 37.0962 14.5007 40.8464 14.7873 41.2296C15.0798 41.6127 16.9166 42.2861 16.9166 42.2861L44.7953 41.9959C44.7953 41.9959 48.5682 39.8827 48.7671 39.6912C48.9602 39.4996 48.9602 38.1528 48.9602 37.8683V26.246C48.9602 26.246 49.6387 11.0651 49.6387 10.8735C49.6387 10.6819 48.2816 5.49199 48.2816 5.49199C48.2816 5.49199 41.7945 3.47754 41.3148 3.47754C40.8352 3.47754 24.1816 3.57042 23.0176 3.57042C21.8535 3.57042 12.6581 4.24384 12.6581 4.24384V4.23804Z",
    fill: "url(#paint9_linear_2347_51594)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.16,
    d: "M12.6581 4.23804C12.6581 4.23804 9.94979 7.59932 10.0434 8.75458C10.137 9.90403 11.2074 23.2621 11.2074 24.1271C11.2074 24.9921 12.272 37.0962 12.272 37.0962C12.272 37.0962 14.5007 40.8464 14.7873 41.2296C15.0798 41.6127 16.9166 42.2861 16.9166 42.2861L44.7953 41.9959C44.7953 41.9959 48.5682 39.8827 48.7671 39.6912C48.9602 39.4996 48.9602 38.1528 48.9602 37.8683V26.246C48.9602 26.246 49.6387 11.0651 49.6387 10.8735C49.6387 10.6819 48.2816 5.49199 48.2816 5.49199C48.2816 5.49199 41.7945 3.47754 41.3148 3.47754C40.8352 3.47754 24.1816 3.57042 23.0176 3.57042C21.8535 3.57042 12.6581 4.24384 12.6581 4.24384V4.23804Z",
    fill: "#034072"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M48.7316 27.3082C48.6263 27.3082 37.8398 27.0586 37.8398 27.0586C37.8398 27.0586 48.3397 28.0165 48.445 28.0165C48.5503 28.0165 48.7316 27.3082 48.7316 27.3082Z",
    fill: "#4AFFFF"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      mixBlendMode: "overlay"
    },
    opacity: 0.07,
    d: "M30.5515 20.9686L10.7041 17.1196C10.9673 20.5041 11.2072 23.7145 11.2072 24.1209C11.2072 24.9858 12.2718 37.0899 12.2718 37.0899C12.2718 37.0899 14.5004 40.8402 14.7871 41.2233C15.0795 41.6065 16.9163 42.2799 16.9163 42.2799L26.7493 42.1754C27.3693 38.8722 30.5515 20.9686 30.5515 20.9686Z",
    fill: "url(#paint10_linear_2347_51594)"
  }), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M41.3086 3.46582C40.8231 3.46582 24.1754 3.55871 23.0114 3.55871C22.7949 3.55871 22.3036 3.58193 21.6426 3.62256C25.047 9.74138 30.7327 19.9413 30.9199 20.2258C31.1071 20.5045 42.1802 25.7641 48.9481 28.9628V26.2343C48.9481 26.2343 49.6266 11.0534 49.6266 10.8618C49.6266 10.6702 48.2695 5.48027 48.2695 5.48027C48.2695 5.48027 41.7824 3.46582 41.3028 3.46582H41.3086Z",
    fill: "url(#paint11_linear_2347_51594)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M48.55 25.1829C48.55 25.1829 48.1581 26.2452 48.0528 26.3497C47.9475 26.46 37.8805 27.058 38.056 27.058C38.2315 27.058 48.3043 27.3773 48.3394 27.3076C48.3745 27.2379 48.9127 26.46 48.9127 26.46L48.5558 25.1829H48.55Z",
    fill: "url(#paint12_linear_2347_51594)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.21
  }, /*#__PURE__*/React.createElement("path", {
    d: "M37.4596 3.48324C35.2192 4.87071 18.1679 18.1069 11.1777 23.6509C11.1953 23.8832 11.2011 24.0457 11.2011 24.1212C11.2011 24.9862 12.2657 37.0903 12.2657 37.0903C12.2657 37.0903 12.8448 38.0656 13.4532 39.0699C18.513 32.3938 32.8677 13.7471 40.7821 3.46582C40.1328 3.46582 38.9395 3.47743 37.4596 3.48324Z",
    fill: "url(#paint13_linear_2347_51594)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.0015 42.1294C34.8797 35.5868 43.613 19.5467 49.2286 9.17259C48.8308 7.59354 48.281 5.4804 48.281 5.4804C48.281 5.4804 47.7486 5.31205 46.9765 5.07983L21.4785 42.2281L31.0074 42.1294H31.0015Z",
    fill: "url(#paint14_linear_2347_51594)"
  }))), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.14,
    d: "M47.059 27.8947L30.9261 20.2258L15.4658 18.3391L30.5517 20.9689L26.9952 38.5242L31.5461 21.4333L47.059 27.8947Z",
    fill: "url(#paint15_linear_2347_51594)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.41,
    d: "M48.7786 34.3613L47.3513 39.0055L44.5026 40.3175L30.5399 40.7994L17.4019 40.1202L14.3835 37.6877L12.1256 32.9506L11.915 32.939C12.1139 35.2379 12.2777 37.084 12.2777 37.084C12.2777 37.084 14.5064 40.8342 14.793 41.2174C15.0855 41.6005 16.9222 42.2739 16.9222 42.2739L44.801 41.9837C44.801 41.9837 48.5739 39.8705 48.7728 39.6789C48.9658 39.4874 48.9658 38.1405 48.9658 37.8561V35.0927C48.8547 34.6341 48.7845 34.3555 48.7845 34.3555L48.7786 34.3613Z",
    fill: "url(#paint16_linear_2347_51594)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M44.7944 41.9896L44.502 40.3176L47.3507 39.0056L48.7604 39.6848L45.2741 41.7806L44.7944 41.9896Z",
    fill: "url(#paint17_linear_2347_51594)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.24,
    d: "M17.3956 40.1259L14.3772 37.6935L12.9675 37.5251L12.8096 38.007C13.4881 39.1448 14.582 40.9561 14.7809 41.2173C15.0733 41.6005 16.9101 42.2739 16.9101 42.2739H17.0622C17.5301 42.0881 17.3897 40.1201 17.3897 40.1201L17.3956 40.1259Z",
    fill: "url(#paint18_linear_2347_51594)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.38,
    d: "M48.2816 5.48588C48.2816 5.48588 41.7945 3.47144 41.3148 3.47144C40.8352 3.47144 24.1816 3.56432 23.0176 3.56432C21.8535 3.56432 12.6581 4.23774 12.6581 4.23774C12.6581 4.23774 9.94979 7.59902 10.0434 8.75428C10.1253 9.73538 10.9091 19.5638 11.1431 22.9947L11.2835 23.2386L11.3537 14.2403L12.1375 8.21439C12.1375 8.21439 14.7054 5.59038 14.9921 5.38139C15.2787 5.16659 29.844 4.17969 31.6983 4.17969C33.5526 4.17969 42.9059 5.31172 43.1223 5.31172C43.3388 5.31172 47.4042 7.29714 47.4042 7.29714C47.4042 7.29714 48.8315 14.0313 48.9777 14.5248C49.0771 14.8789 49.1064 19.767 49.1181 22.571C49.317 18.066 49.6328 11.0009 49.6328 10.8732C49.6328 10.6816 48.2758 5.49169 48.2758 5.49169L48.2816 5.48588Z",
    fill: "#034072"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M48.2806 5.4858C48.2806 5.4858 45.9876 4.77175 44.028 4.19702L43.2441 5.34067C43.9461 5.60191 47.409 7.29126 47.409 7.29126L48.3683 5.83412C48.3098 5.61352 48.2747 5.4858 48.2747 5.4858H48.2806Z",
    fill: "url(#paint19_linear_2347_51594)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M14.9912 5.3755C14.9912 5.3755 15.1199 5.34067 15.2895 5.31164L13.1544 4.19702C12.8385 4.22024 12.6514 4.23185 12.6514 4.23185C12.6514 4.23185 11.0194 6.25211 10.335 7.69763L12.1308 8.2085C12.1308 8.2085 14.6987 5.58449 14.9853 5.3755H14.9912Z",
    fill: "url(#paint20_linear_2347_51594)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M10.0951 8.0694V10.2986C10.0951 10.2986 6.88961 17.1489 6.97735 16.9864C7.05925 16.818 10.4286 11.5758 10.4286 11.5758L10.4695 15.9124C10.4695 15.9124 10.8848 11.4539 10.8848 11.2043C10.8848 10.9546 10.5514 7.94169 10.762 7.90105C10.9726 7.86041 13.172 4.39463 13.2188 4.43527C13.2597 4.47591 18.4599 3.85474 18.4599 3.85474L26.2164 3.49481L17.5006 3.44256L18.5009 0.510869L16.67 3.4832L15.2954 3.40192C15.2954 3.40192 12.9731 0.116107 12.7508 0H12.7333C12.6748 0.145133 14.6695 3.61091 14.5466 3.65155C14.4238 3.69219 13.2539 3.73282 13.2539 3.73282L10.1185 0.0638586L12.5051 3.86054L10.0951 8.0694Z",
    fill: "url(#paint21_linear_2347_51594)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5732 8.88198C49.5732 8.72524 48.3857 4.9808 48.3857 4.9808C48.3857 4.9808 50.8484 2.19425 50.667 2.35099C50.4798 2.50773 47.637 4.73698 47.5785 4.67312C47.52 4.60926 45.1158 3.80813 45.1743 3.71524C45.2387 3.62236 47.4498 0.650029 47.4498 0.650029L44.332 3.74427C44.332 3.74427 40.8984 3.27984 40.9276 3.1231C40.951 3.00699 42.6123 1.17831 43.4078 0.301709C43.3727 0.301709 43.3434 0.301709 43.3084 0.301709L40.2725 2.97216L36.0608 2.94313L32.8787 0.13916C32.6681 0.13916 32.4517 0.13916 32.2352 0.13916L32.4751 0.301709C32.4751 0.301709 35.6864 3.18115 35.4408 3.27404C35.1892 3.36692 32.165 3.55269 32.165 3.55269C32.165 3.55269 41.3078 3.6746 41.5886 3.76749C41.8694 3.86037 44.3964 4.3248 44.3964 4.3248L47.1866 5.21882L47.988 5.47425C47.988 5.47425 49.1754 9.776 49.2982 9.776C49.4211 9.776 49.579 11.9414 49.579 11.9414L50.047 9.61926L53.6327 8.06923C53.6327 8.06923 49.579 9.02711 49.579 8.87617L49.5732 8.88198Z",
    fill: "url(#paint22_linear_2347_51594)"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M49.5851 14.333L49.3862 24.3008C49.3862 24.3008 53.9489 17.7407 53.75 18.1355C53.5511 18.5303 49.5208 25.1541 49.5208 25.1541L53.5628 24.4517L49.2576 25.6824L49.1289 38.9302L52.0887 42.8372L48.7662 39.6849C48.7662 39.6849 48.3977 26.4661 48.4679 25.7463C48.5322 25.0264 49.591 14.333 49.591 14.333H49.5851Z",
    fill: "url(#paint23_linear_2347_51594)"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.59,
    d: "M10.0254 23.4759L8.69761 23.1276L6.58594 22.4658C6.79652 23.0347 7.08315 24.3061 7.08315 24.3061C7.08315 24.3061 7.01295 24.9505 6.93106 25.5601L10.0254 23.4818V23.4759Z",
    fill: "url(#paint24_linear_2347_51594)"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5696 17.8105V22.8728L11.5173 33.8971C11.5173 33.8971 6.91369 31.0641 7.16522 31.1686C7.41675 31.2673 11.2189 34.7447 11.4705 34.9943C11.722 35.2439 11.9209 37.1771 11.9209 37.1771L7.9198 40.0101L12.4766 38.1234L14.8573 41.2641L12.9796 37.5312C12.9796 37.5312 12.0262 33.3572 12.1256 32.9624C12.225 32.5677 11.0727 22.3387 11.0727 22.0891C11.0727 21.8394 10.5696 17.8164 10.5696 17.8164V17.8105Z",
    fill: "url(#paint25_linear_2347_51594)"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0029 46.0297L15.3483 45.0892L16.758 46.1168L16.7639 43.0574L14.0029 46.0297Z",
    fill: "url(#paint26_linear_2347_51594)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M47.5791 40.3C47.0059 40.5439 44.8357 41.5308 44.8357 41.5308C44.8357 41.5308 29.9429 41.7572 29.2877 41.7572C28.6326 41.7572 21.1043 42.0823 20.2853 42.1636C19.4664 42.2448 16.916 42.2739 16.916 42.2739C16.916 42.2739 21.0224 42.5699 21.0984 42.6512C21.1803 42.7325 19.7881 45.7396 19.7881 45.7396C19.7881 45.7396 21.6717 42.7325 21.9992 42.8138C22.3268 42.895 35.0085 42.1636 35.0085 42.1636L45.4031 42.3261L49.4159 45.3333L46.2513 41.6469L47.5791 40.3Z",
    fill: "#4AFFFF"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M49.2578 25.6767C49.2578 25.6767 51.5801 26.2224 53.2296 26.681L52.6505 26.443L53.6391 24.4402L49.2578 25.6709V25.6767Z",
    fill: "url(#paint27_linear_2347_51594)"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M11.4058 13.8049L10.5459 15.0937C10.7799 18.066 11.0256 21.3054 11.1425 22.9948L11.2829 23.2386L11.3531 14.2403L11.4116 13.8107L11.4058 13.8049Z",
    fill: "url(#paint28_linear_2347_51594)"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.35,
    d: "M48.9822 14.5128C49.0524 14.7624 49.0934 17.2994 49.1051 19.7492C49.1519 19.7376 49.1987 19.7318 49.2455 19.7202C49.4268 15.5752 49.6315 10.9658 49.6315 10.8555C49.6315 10.8148 49.573 10.5652 49.4853 10.1995L48.2979 11.4476C48.6196 12.9338 48.9179 14.2922 48.9764 14.507L48.9822 14.5128Z",
    fill: "url(#paint29_linear_2347_51594)"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.55,
    d: "M13.4945 45.385C12.7867 45.6637 12.1959 45.7972 11.9678 45.8436C12.9095 45.9713 14.0034 46.0294 14.0034 46.0294L14.0736 45.9771L16.7585 43.0513C16.7585 43.0513 14.3895 45.0251 13.4886 45.3792L13.4945 45.385Z",
    fill: "#4AFFFF"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M18.6648 46.1001C18.1208 46.0072 17.2784 45.8562 17.2609 45.8156C17.2316 45.7517 16.7695 43.1858 16.7695 43.1858C16.7812 43.2613 16.7695 45.4847 16.7695 46.1117C16.8456 46.1117 17.5358 46.1117 18.6648 46.0943V46.1001Z",
    fill: "#4AFFFF"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M8.70347 23.1225L6.5918 22.4607C6.72634 22.8206 6.89012 23.4534 6.98956 23.8772C7.28789 23.8656 8.67422 23.7959 9.65694 23.7205L10.0313 23.4708L8.70347 23.1225Z",
    fill: "url(#paint30_linear_2347_51594)"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M16.9219 32.5042C16.9219 32.5042 20.9463 31.4302 22.3268 31.6102C23.7073 31.7901 25.9945 32.2662 25.6318 32.5622C25.2691 32.8583 24.07 33.2357 23.409 33.2183C21.0633 33.1602 16.9219 32.5042 16.9219 32.5042Z",
    fill: "url(#paint31_linear_2347_51594)"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.32,
    d: "M27.024 32.3877C26.8075 32.3877 25.9477 32.3238 25.3978 32.2832C25.6318 32.3819 25.7312 32.4806 25.6318 32.5619C25.2691 32.8579 24.07 33.2353 23.409 33.2179C21.0633 33.1598 16.9219 32.5038 16.9219 32.5038C16.9219 32.5038 21.8296 33.6533 22.9878 33.7984C24.1519 33.9435 25.9652 32.7534 26.4039 32.678C26.8426 32.6083 27.3515 32.3877 27.024 32.3877Z",
    fill: "#4AFFFF"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.33,
    d: "M18.7061 32.4283C18.7061 32.4283 21.1979 31.7665 22.6194 31.9349C24.0467 32.1032 25.0645 32.4632 25.0645 32.4632L18.7061 32.4283Z",
    fill: "url(#paint32_linear_2347_51594)"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2347_51594)",
    filter: "url(#filter1_d_2347_51594)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 23.9902,
    y: 13.6497,
    width: 4.21053,
    height: 18.9474,
    rx: 2.10526,
    fill: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.3584,
    y: 13.6497,
    width: 4.21053,
    height: 18.9474,
    rx: 2.10526,
    fill: "#F6F6F6"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_2347_51594",
    x: 0.518658,
    y: 0,
    width: 58.4168,
    height: 55.9827,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.86806
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2.43403
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2347_51594"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2347_51594",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_2347_51594",
    x: 14.7266,
    y: 13.1233,
    width: 30,
    height: 28,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_2347_51594"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_2347_51594",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2347_51594",
    x1: 24.6433,
    y1: 59.8181,
    x2: 35.4714,
    y2: -30.9038,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#53ECFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2347_51594",
    x1: 24.6433,
    y1: 59.8181,
    x2: 35.4714,
    y2: -30.9038,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#53ECFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2347_51594",
    x1: 34.5348,
    y1: 27.5868,
    x2: 27.6037,
    y2: 56.353,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#060092"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3142FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2347_51594",
    x1: 44.5601,
    y1: 31.0755,
    x2: 38.9441,
    y2: 55.5346,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#060092"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3142FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2347_51594",
    x1: 16.9985,
    y1: 8.57436,
    x2: 23.7067,
    y2: -3.23689,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#65FCFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2347_51594",
    x1: 44.9404,
    y1: 7.62224,
    x2: 49.4106,
    y2: -0.261559,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#65FCFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2347_51594",
    x1: 4.74327,
    y1: 12.3594,
    x2: 12.5618,
    y2: -1.40389,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#65FCFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2347_51594",
    x1: 56.4465,
    y1: 19.4184,
    x2: 48.5501,
    y2: 36.8853,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#53ECFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2347_51594",
    x1: 15.2433,
    y1: -8.88212,
    x2: 11.0856,
    y2: 7.85787,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#060092"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3142FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2347_51594",
    x1: 28.8437,
    y1: -9.89793,
    x2: 34.1214,
    y2: 96.4074,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#53ECFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2347_51594",
    x1: 42.8822,
    y1: -4.8245,
    x2: 2.54412,
    y2: 53.62,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#65FCFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2347_51594",
    x1: 28.8609,
    y1: -24.6842,
    x2: 41.821,
    y2: 37.2518,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#060092"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3142FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2347_51594",
    x1: 50.6266,
    y1: 16.5736,
    x2: 38.821,
    y2: 33.6787,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#060092"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3142FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2347_51594",
    x1: 38.0855,
    y1: -12.7949,
    x2: 6.91586,
    y2: 56.1185,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#53ECFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2347_51594",
    x1: 50.457,
    y1: -7.19843,
    x2: 19.2932,
    y2: 61.7207,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#53ECFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2347_51594",
    x1: 25.6557,
    y1: -3.28573,
    x2: 35.0817,
    y2: 41.775,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#060092"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3142FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2347_51594",
    x1: 29.5396,
    y1: 16.4344,
    x2: 31.343,
    y2: 52.4927,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#53ECFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2347_51594",
    x1: 46.1866,
    y1: 41.1884,
    x2: 42.6772,
    y2: 50.6453,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFCFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_2347_51594",
    x1: 14.9154,
    y1: 40.3117,
    x2: 11.6657,
    y2: 49.0765,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFCFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_2347_51594",
    x1: 45.4904,
    y1: -0.650425,
    x2: 46.0435,
    y2: 10.3569,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#53ECFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_2347_51594",
    x1: 12.4057,
    y1: -1.55606,
    x2: 13.074,
    y2: 11.8025,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#53ECFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_2347_51594",
    x1: 15.7867,
    y1: -5.80533,
    x2: 18.0223,
    y2: 39.3154,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFCFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_2347_51594",
    x1: 50.4915,
    y1: -25.8861,
    x2: 38.5663,
    y2: 22.1781,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFCFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_2347_51594",
    x1: 70.8773,
    y1: -50.9827,
    x2: 40.0203,
    y2: 73.3904,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFCFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_2347_51594",
    x1: 10.1307,
    y1: 15.7258,
    x2: 6.80342,
    y2: 29.1422,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#060092"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3142FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_2347_51594",
    x1: 29.0599,
    y1: -35.4649,
    x2: 3.76769,
    y2: 66.4797,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFFCFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_2347_51594",
    x1: 14.0029,
    y1: 44.5842,
    x2: 16.7639,
    y2: 44.5842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#060092"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3142FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_2347_51594",
    x1: 53.1828,
    y1: 20.8467,
    x2: 50.4125,
    y2: 28.5696,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#060092"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3142FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_2347_51594",
    x1: 10.2476,
    y1: 0.0869468,
    x2: 11.8378,
    y2: 31.8723,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#53ECFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_2347_51594",
    x1: 48.216,
    y1: -3.65204,
    x2: 49.8235,
    y2: 28.4759,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00AEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#53ECFF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_2347_51594",
    x1: 8.42854,
    y1: 20.812,
    x2: 8.18079,
    y2: 25.2823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#060092"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3142FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_2347_51594",
    x1: 21.4845,
    y1: 28.6553,
    x2: 21.012,
    y2: 38.4956,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#060092"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3142FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_2347_51594",
    x1: 21.9701,
    y1: 30.6171,
    x2: 21.7627,
    y2: 34.9422,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#060092"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3142FF"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2347_51594"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 20,
    fill: "white",
    transform: "translate(18.7266 13.1233)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPauseButton);
export default __webpack_public_path__ + "static/media/pause-button.svg";
export { ForwardRef as ReactComponent };